import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {VACCINATED_REQUEST} from "../vaccinatedReducer";


const initialState = false;

export const vaccinatedLoaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${VACCINATED_REQUEST}${START}`:
            return true;
        case `${VACCINATED_REQUEST}${SUCCESS}`:
            return false;
        case `${VACCINATED_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};